import { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'transmute/compose';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import SharedDragDropContext from 'customer-data-ui-utilities/dnd/SharedDragDropContext';
import { jsx as _jsx } from "react/jsx-runtime";
const DnDColumnManagement = BaseComponent => {
  var _class;
  return _class = class extends Component {
    constructor(...args) {
      super(...args);
      this.getValue = () => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
        const {
          value
        } = this.props;
        return value;
      };
      this.handleAddOption = (item, at) => {
        const option = item.data && item.data.option || item;
        const value = this.getValue().slice();
        at = at === -1 ? value.length : at;
        value.splice(at || value.length, 0, option);
        this.props.onChange(value);
      };
      this.handleRemoveOption = option => {
        const currentValues = this.getValue();
        const newValues = currentValues.filter(({
          value
        }) => !(option.value === value));
        this.props.onChange(newValues);
      };
      this.handleReorderOption = (from, to) => {
        if (from === to) {
          return;
        }
        const value = this.getValue().slice();

        // make sure we move it below the "sticky" disabled columns if it's going to the top (to===0)
        const toIdx = !to ? value.reduce((acc, cur, idx) => {
          if (cur.disabled) return idx + 1;
          return acc;
        }, 0) : to;
        const removed = value.splice(from, 1)[0];
        value.splice(toIdx, 0, removed);
        this.props.onChange(value);
      };
      this.handleSave = () => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
        const {
          value
        } = this.props;
        const nextValue = this.getValue();
        if (nextValue !== value) {
          this.props.onChange(nextValue);
        }
      };
      this.handleReset = () => {};
    } // for a temp refactor we are making handle reset a no-op as it is vestigial but we do not have the time to remove refs in child components
    render() {
      return /*#__PURE__*/_jsx(BaseComponent, Object.assign({}, this.props, {
        value: this.getValue(),
        onAddOption: this.handleAddOption,
        onRemoveOption: this.handleRemoveOption,
        onReorderOption: this.handleReorderOption,
        onReset: this.handleReset,
        onSave: this.handleSave
      }));
    }
  }, _class.displayName = 'DnDColumnManagement', _class.propTypes = {
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
  }, _class;
};
export default compose(SharedDragDropContext(), DnDColumnManagement);